<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p8
        Take Folic Acid Scientifically
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p8" title="mthfr-p8">
    <img-card class="card">
      <div slot="title" style="width:100%;">{{$t('Mthfr.P8_Title')}}</div>
      <!-- <p class="p-content">{{$t('Mthfr.P9_Content')}}</p> -->

      <div class="table-wrapper">
        <table id="cu-table">
          <thead></thead>
          <thead>
          <tr>
            <th v-for="th in ths">{{th}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td rowspan="3" class="tt">{{tds1[0]}}
            </td>
            <td v-for="td in tds1.slice(1)">{{td}}</td>
          </tr>
          <tr>
            <td v-for="td in tds2.slice(1)">{{td}}</td>
          </tr>
          <tr>
            <td v-for="td in tds3.slice(1)">{{td}}</td>
          </tr>
          <tr>
            <td rowspan="3">{{tds4[0]}}
              <div class="line-td">

              </div>
            </td>
            <td v-for="td in tds4.slice(1)">{{td}}</td>
          </tr>
          <tr>
            <td v-for="td in tds5.slice(1)">{{td}}</td>
          </tr>
          <tr>
            <td v-for="td in tds6.slice(1)">{{td}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="need">
        <div class="left">
          <div class="left-titles">
            <div class="normal">{{$t('Mthfr.P8_2_1')}}</div>
            <div class="lg">{{$t('Mthfr.P8_2_3')}}</div>
          </div>
          <div class="left-info">
            <div class="normal">{{$t('Mthfr.P8_2_2')}}</div>
            <div class="lg">{{$t('Mthfr.P8_2_4')}}</div>
          </div>
        </div>
        <div class="right">
          <div>{{$t('Mthfr.P8_3_1')}}</div>
          <div>{{$t('Mthfr.P8_3_2')}}</div>
          <div>{{$t('Mthfr.P8_3_3')}}</div>
        </div>
      </div>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p8",
    components: {ImgCard},
    computed: {
      ths() {
        return this.$t('Mthfr.P8_1').split('\t')
      },
      tds1() {
        return this.$t('Mthfr.P8_2').split('\t')
      },
      tds2() {
        return this.$t('Mthfr.P8_3').split('\t')
      },
      tds3() {
        return this.$t('Mthfr.P8_4').split('\t')
      },
      tds4() {
        return this.$t('Mthfr.P8_5').split('\t')
      },
      tds5() {
        return this.$t('Mthfr.P8_6').split('\t')
      },
      tds6() {
        return this.$t('Mthfr.P8_7').split('\t')
      }
    }
  }
</script>

<style lang="scss">
  .en{
    .v-mthfr-p8{
      p.p-content{
        display: block;
      }
    }
  }
</style>
<style lang="scss">
  .v-mthfr-p8 {
    p.p-content{
      display: none;
      padding-bottom: 20px;
    }

    .table-wrapper #cu-table .tt {
      background-color: rgba(251, 207, 192, 0.2);
    }

    .line-td {
      position: relative;

      &:before {
        content: ' ';
        display: block;
        position: absolute;
        top: -88px;
        left: -20px;
        width: 162%;
        height: 3px;
        background: white;
      }
    }


    .need {
      margin-top: 30px;
      color: #999;
      display: flex;

      .left {
        flex-shrink: 0;
        margin-right: 30px;
        display: flex;

        .left-titles {
          color: #fff;

          & > div {
            padding: 8px 12px;
          }

          .normal {
            background: #e89db6;
            padding-bottom: 6px;
            margin-bottom: 1px;
          }

          .lg {
            background: #c03239;
            padding-top: 6px;
          }
        }

        .left-info {
          & > div {
            padding: 8px 80px 8px 12px;
          }

          .normal {
            padding-bottom: 6px;
            border-bottom: 1px solid #999;
          }

          .lg {
            padding-top: 6px;
          }
        }
      }

      .right {
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p8.vue